<template>
    <BaseDialog v-model:open="open" :title="dialogTitle" show-close dialog-content-class="p-4 md:max-w-5xl overflow-hidden rounded-xl">
        <BaseHeader v-if="headerText" usage="nadia" class="mb-4 pb-4 border-b border-valence-grey-200">{{ headerText }}</BaseHeader>
        <div class="relative pb-[56.25%] h-0">
            <iframe
                v-if="hasOpened"
                :src="demoUrl"
                :title="headerText ?? dialogTitle"
                loading="lazy"
                allow="clipboard-write"
                allowfullscreen
                class="absolute inset-0 w-full h-full border-0" />
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseDialog from "~vue/components/BaseDialog.vue";
import { ref, watch } from "vue";

import BaseHeader from "./BaseHeader.vue";

interface Props {
    dialogTitle?: string;
    headerText?: string;
    demoUrl: string;
}

withDefaults(defineProps<Props>(), {
    dialogTitle: "Product demo",
});

const open = defineModel<boolean>("open", { default: false });
const hasOpened = ref(false);

watch(open, (isOpen) => {
    if (isOpen && !hasOpened.value) {
        hasOpened.value = true;
    }
});
</script>
